import { SVGProps } from 'react'

import { wrapIllustration } from '../wrap-illustration'

function SvgCourts(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={160}
      height={160}
      viewBox="0 0 120 120"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M50.5 58h45v22.5h-45V58Z" fill="#CAE8DF" />
      <path d="M25.5 58h25v22.5h-25V58Z" fill="#A6DBCB" />
      <path
        d="M93.913 61.654A4.986 4.986 0 0 0 95.5 58h-10c0 1.442.61 2.741 1.587 3.654a4.986 4.986 0 0 0-1.587 3.653V80.5h10V65.307c0-1.442-.61-2.741-1.587-3.654Z"
        fill="#78B441"
      />
      <path
        d="M95.5 65.294V73c-5.064 0-9.248-3.764-9.91-8.647a4.993 4.993 0 0 1 1.497-2.7A4.986 4.986 0 0 1 85.5 58h10a5.016 5.016 0 0 1-1.587 3.654 4.987 4.987 0 0 1 1.587 3.64Z"
        fill="#599F40"
      />
      <path
        d="M78.913 61.654A4.986 4.986 0 0 0 80.5 58h-10c0 1.442.61 2.741 1.587 3.654a4.986 4.986 0 0 0-1.587 3.653V80.5h10V65.307c0-1.442-.61-2.741-1.587-3.654Z"
        fill="#78B441"
      />
      <path
        d="M80.5 65.294V73c-5.064 0-9.248-3.764-9.91-8.647a4.993 4.993 0 0 1 1.497-2.7A4.986 4.986 0 0 1 70.5 58h10a5.016 5.016 0 0 1-1.587 3.654 4.987 4.987 0 0 1 1.587 3.64Z"
        fill="#599F40"
      />
      <path
        d="M63.913 61.654A4.986 4.986 0 0 0 65.5 58h-10c0 1.442.61 2.741 1.587 3.654a4.986 4.986 0 0 0-1.587 3.653V80.5h10V65.307c0-1.442-.61-2.741-1.587-3.654Z"
        fill="#78B441"
      />
      <path
        d="M65.5 65.294V73c-5.064 0-9.248-3.764-9.91-8.647a4.993 4.993 0 0 1 1.497-2.7A4.986 4.986 0 0 1 55.5 58h10a5.016 5.016 0 0 1-1.587 3.654 4.987 4.987 0 0 1 1.587 3.64Z"
        fill="#599F40"
      />
      <path
        d="M49.7 79V59.5a.8.8 0 0 1 1.6 0V79a.8.8 0 1 1-1.6 0ZM92 47.2a.8.8 0 0 1 0 1.6H54a.8.8 0 0 1 0-1.6h38ZM72.167 21.667a.8.8 0 1 1 1.13 1.13l-23 23a.8.8 0 1 1-1.13-1.13l23-23Z"
        fill="#fff"
      />
      <path d="M20.5 48h40v10h-34a6 6 0 0 1-6-6v-4Z" fill="#599F40" />
      <path d="M50.5 48h50v4a6 6 0 0 1-6 6h-38a6 6 0 0 1-6-6v-4Z" fill="#78B441" />
      <path d="M97 48h-5L73 29l2.5-2.5L97 48Z" fill="#599F40" />
      <path d="M92 48H54l19-19 19 19Z" fill="#CAE8DF" />
      <path
        d="M76.5 37.5s-1 3.5-1 3.875v.125a1 1 0 1 0 2 0v-.125c0-.375-1-3.875-1-3.875Z"
        fill="#78B441"
      />
      <path
        d="M76.7 41.375c0 .05.005.04-.026-.111-.025-.118-.06-.275-.107-.461-.02-.082-.044-.168-.067-.258-.023.09-.047.176-.067.258-.046.186-.082.343-.107.46-.015.075-.022.116-.024.132l-.002-.02v.125a.2.2 0 0 0 .4 0v-.125Zm1.6.125a1.8 1.8 0 1 1-3.6 0v-.125c0-.145.036-.324.06-.437.03-.145.072-.324.12-.518.096-.39.222-.87.348-1.332.125-.464.251-.916.345-1.251l.115-.404.032-.113.008-.029c0-.003.002-.006.003-.008v-.003a.8.8 0 0 1 1.538 0v.003l.003.008.008.03.032.112.115.404c.094.335.22.787.345 1.25.126.463.252.943.348 1.333.048.194.09.373.12.518.024.113.06.292.06.437v.125ZM69.5 37.5s-1 3.5-1 3.875v.125a1 1 0 1 0 2 0v-.125c0-.375-1-3.875-1-3.875Z"
        fill="#78B441"
      />
      <path
        d="M69.7 41.375c0 .05.005.04-.026-.111-.025-.118-.06-.275-.107-.461-.02-.082-.044-.168-.067-.258-.023.09-.047.176-.067.258-.046.186-.082.343-.107.46-.015.075-.022.116-.024.132l-.002-.02v.125a.2.2 0 0 0 .4 0v-.125Zm1.6.125a1.8 1.8 0 1 1-3.6 0v-.125c0-.145.036-.324.06-.437.03-.145.072-.324.12-.518.096-.39.222-.87.348-1.332.125-.464.251-.916.345-1.251l.115-.404.032-.113.008-.029c0-.003.002-.006.003-.008v-.003a.8.8 0 0 1 1.538 0v.003l.003.008.008.03.032.112.115.404c.094.335.22.787.345 1.25.126.463.252.943.348 1.333.048.194.09.373.12.518.024.113.06.292.06.437v.125ZM72.2 45.5v-9a.8.8 0 1 1 1.6 0v9a.8.8 0 1 1-1.6 0Z"
        fill="#78B441"
      />
      <path
        d="M74 44.7a.8.8 0 1 1 0 1.6h-2a.8.8 0 1 1 0-1.6h2ZM76.5 36.7a.8.8 0 1 1 0 1.6h-7a.8.8 0 1 1 0-1.6h7Z"
        fill="#78B441"
      />
      <path
        d="M45.5 20.5a2.5 2.5 0 0 0-1.768.732l-25 25A2.5 2.5 0 0 0 20.5 50.5h30v-.732l25-25.213V20.5h-30Z"
        fill="#599F40"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M73.732 21.232a2.5 2.5 0 0 1 3.536 0l25 25a2.5 2.5 0 0 1-3.536 3.536L75.5 26.535 52.268 49.769a2.5 2.5 0 0 1-3.536-3.536l25-25Z"
        fill="#78B441"
      />
      <path d="M50.5 52.2a.8.8 0 1 1 0 1.6h-30a.8.8 0 1 1 0-1.6h30Z" fill="#0F172A" />
      <path
        d="M100.5 52.2a.8.8 0 1 1 0 1.6h-50a.8.8 0 1 1 0-1.6h50ZM95.5 57.2a.8.8 0 1 1 0 1.6h-70a.8.8 0 1 1 0-1.6h70Z"
        fill="#0F172A"
      />
      <path
        d="M15.5 92.5a2 2 0 0 1 2-2h31a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2h-31a2 2 0 0 1-2-2v-6Z"
        fill="#007A5F"
      />
      <path
        d="M45.5 92.5a2 2 0 0 1 2-2h56a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2h-56a2 2 0 0 1-2-2v-6Z"
        fill="#80CCB5"
      />
      <path d="M20.5 82.5a2 2 0 0 1 2-2h31a2 2 0 0 1 2 2v8h-35v-8Z" fill="#007A5F" />
      <path d="M50.5 82.5a2 2 0 0 1 2-2h46a2 2 0 0 1 2 2v8h-50v-8Z" fill="#80CCB5" />
      <path
        d="M95.5 79.7a.8.8 0 1 1 0 1.6h-70a.8.8 0 1 1 0-1.6h70ZM100.5 89.7a.8.8 0 1 1 0 1.6h-80a.8.8 0 1 1 0-1.6h80Z"
        fill="#0F172A"
      />
    </svg>
  )
}
export default wrapIllustration(SvgCourts)
